import { useCallback, useContext } from 'react';

import type { ContestManageModalType } from '../components/Modals/ContestManageModalsContext';
import { ContestManageModalsContext } from '../components/Modals/ContestManageModalsContext';

function useHandleTextClick() {
  const { openModal } = useContext(ContestManageModalsContext);

  return useCallback((e: React.MouseEvent<HTMLElement>) => {
    const target = e.target as HTMLElement | null;
    const anchorElement = target?.closest('a');

    if (anchorElement) {
      const modalName = anchorElement.getAttribute('data-modal');

      if (!modalName) { return; }

      const modalPayload = (() => {
        const payload = anchorElement.getAttribute('data-modal-payload');

        if (!payload) { return; }

        try {
          return JSON.parse(decodeURIComponent(payload));
        } catch (error) {
          return null;
        }
      })();

      e.preventDefault();
      openModal({
        type: modalName,
        ...(modalPayload ?? {}),
      } as ContestManageModalType);
    }
  }, [openModal]);
}

export default useHandleTextClick;
